import { Box, Paper, Stack, Tooltip, Typography } from '@mui/material';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { formatMetric, metricValue } from './metrics';

const VALUE_SIZE = 26;
const VALUE_LINE_HEIGHT = 34;

/**
 * A KPI: the value for the range and its change against the previous period. The change stays in text colours:
 * more spend or impressions is not good or bad on its own. Long values shrink to fit the tile rather than being cut
 * off.
 */
export default function StatTile({ metric, totals, previous, currency, previousLabel }) {
  const value = metricValue(totals, metric);
  const before = metricValue(previous, metric);
  const change = value != null && before ? (value - before) / before : null;
  const formatted = formatMetric(value, metric, currency);
  const Icon = change == null ? null : Math.abs(change) < 0.005 ? TrendingFlatIcon
    : change > 0 ? TrendingUpIcon : TrendingDownIcon;

  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, minWidth: 0 }}>
      <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>{metric.label}</Typography>
      <Box sx={{ containerType: 'inline-size', mt: 0.5 }}>
        {/* a character is at most about 0.62em wide at this weight */}
        <Typography sx={{ fontSize: `min(${VALUE_SIZE}px, calc(100cqw / ${formatted.length * 0.62}))`, fontWeight: 600,
          lineHeight: `${VALUE_LINE_HEIGHT}px`, whiteSpace: 'nowrap', color: 'text.primary' }}>
          {formatted}
        </Typography>
      </Box>
      <Tooltip title={`${previousLabel}: ${formatMetric(before, metric, currency)}`}>
        <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mt: 0.5, color: 'text.secondary' }}>
          {Icon && <Icon sx={{ fontSize: 18 }} />}
          <Typography variant="caption" sx={{ fontSize: 12.5 }} noWrap>
            {change == null ? 'No earlier data' : (
              <>
                <Box component="span" sx={{ fontWeight: 600, color: 'text.primary' }}>
                  {`${change > 0 ? '+' : ''}${(change * 100).toFixed(1)}%`}
                </Box>
                {' vs previous'}
              </>
            )}
          </Typography>
        </Stack>
      </Tooltip>
    </Paper>
  );
}
